// Centralized constants for all filter selectors across the app
// This ensures consistency and makes it easy to update values globally

// Container/Wrapper Dimensions (for the TextField itself)
// All filter selector TextFields use width: "100%", maxWidth: FILTER_SELECTOR_WIDTH
// This makes them fill available space up to the max width
export const FILTER_SELECTOR_WIDTH = "300px";

// Popper/Dropdown Dimensions - Each selector can have its own width based on content needs
export const POPPER_WIDTHS = {
  dashboard: 400, // Needs space for date range + service/view side by side
  calendar: 900, // Wide layout for view + filter side by side + day calendar + month calendar
  tasks: 650, // Multiple filter sections (due dates, types, priorities, members)
  reports: 800, // Wide layout for months/years + clients/linguists/categories
};

export const POPPER_CONFIG = {
  zIndex: 1300,
};

// Paper/Content Dimensions (inside popper)
export const PAPER_CONFIG = {
  padding: 2, // 16px - used in theme.spacing(2)
  elevation: 8,
  borderRadius: "12px",
  minWidth: 400, // For dashboard filter selector
};

// Calculate content width based on popper width and padding
// Content width = Popper width - (padding * 2 * 8px)
// For dashboard: 400px - (2 * 2 * 8px) = 400 - 32 = 368px
export const CONTENT_WIDTH =
  POPPER_WIDTHS.dashboard - PAPER_CONFIG.padding * 2 * 8;

// Date Range Section Dimensions
export const DATE_RANGE_CONFIG = {
  width: CONTENT_WIDTH, // 288px
  monthGridSize: 3, // 4 columns (12/3 = 4)
  yearGridSize: 4, // 3 columns (12/4 = 3)
};

// Grid Configurations for buttons
export const GRID_SIZES = {
  month: { xs: DATE_RANGE_CONFIG.monthGridSize },
  year: { xs: DATE_RANGE_CONFIG.yearGridSize },
  twoColumn: 6, // For service/view options
};

// Spacing
export const SPACING = {
  containerGap: 2,
  gridSpacing: 1,
  verticalGap: 2,
  buttonPadding: 1,
};

// Transitions
export const TRANSITIONS = {
  opacity: "opacity 0.2s",
};

// Responsive breakpoints for filter selector containers
export const FILTER_CONTAINER_GRID = {
  xs: 12,
  sm: 6,
  md: 4,
};
